import { createSlice } from "@reduxjs/toolkit";
import { getPagination, getPageNumber } from "../Common/paginationHelper";

const pageSize = 12;
export const reportSlice = createSlice({
  name: "report",
  initialState: {
    data: [],
    pages: null,
    pageNumber: 0,
    metadata: { filters: [] },
    filterSettings: {},
    sortSettings: [],
  },
  reducers: {
    setData: (state = {}, action) => {
      const data = action.payload;
      state.data = data;
      state.pages = getPagination(data, pageSize);
      state.pageNumber = getPageNumber(data, pageSize);
    },
    setMetadata: (state = {}, action) => {
      state.metadata = action.payload;
    },
    setFilterSettings: (state = {}, action) => {
      state.filterSettings[action.payload.name] = action.payload.value;
    },
    setSortSettings: (state = {}, action) => {
      state.sortSettings = action.payload;
    },
  },
});

export const {
  setData,
  setMetadata,
  setSchools,
  setFilterSettings,
  setSortSettings,
} = reportSlice.actions;

export const selectData = (state) => state.report.data;
export const selectPages = (state) => state.report.pages;
export const selectMetadata = (state) => state.report.metadata;
export const selectFilterSettings = (state) => state.report.filterSettings;
export const selectSortSettings = (state) => state.report.sortSettings;

export default reportSlice.reducer;
